import React from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
    display: flex;
    width: 90%;
    margin-bottom: 1rem;

    border-bottom:1px solid #5A5A5A;
`
const Box = styled.div`
`
const Row = styled.div`

    display:flex;
    justify-content: space-between;


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        font-size: 1rem;
        font-family: "Poppins";
        font-weight: 600;
    }


`
const Space = styled.div`
    width: 90px;
`


const CardDataTinyTransporterInfo = ({ client, number,data }) => {

    return (
        <CardWrapper>
            <Box>
                <BoxText>
                    <p className='textPrimary'>Transportador / Volumes</p>
                </BoxText>
                <BoxText>
                    <p>Forma de envio</p>
                    <p className='textPrimary'>{data?.type_delivery == 1 ? "Tracken" : "Jadlog"}</p>
                </BoxText>
                <BoxText>
                    <p>Frete por conta</p>
                    <p className='textPrimary'>Por conta do Remetente</p>
                </BoxText>
                <BoxText>
                    <p>Qtde Volumes</p>
                    <p className='textPrimary'>0</p>
                </BoxText>
            </Box>
            <Box>
                <BoxText>
                    <p className='textPrimary'></p>
                </BoxText>
                <BoxText>
                    <p>Forma de frete</p>
                    <p className='textPrimary'>Não definida</p>
                </BoxText>

                <BoxText>
                    <p></p>
                    <p className='textPrimary'></p>
                </BoxText>

                
                    <BoxText>
                        <p>Enviar para expedição</p>
                        <p className='textPrimary'>Sim</p>
                    </BoxText>

            </Box>

        </CardWrapper>
    )
}

export default CardDataTinyTransporterInfo